export const config = {
  SITE_NAME: 'Remind Me To Stand',
  ANALYTICS_ID: 'UA-53906010-3',
  ANALYTICS_DEBUG: false,
};